// extracted by mini-css-extract-plugin
export default {"notice":"Notice_notice__j386o","icon":"Notice_icon__9TdTK"};